// extracted by css-extract-rspack-plugin
export default {"cls1":"PreprintSuggestionsStep-cls1_I4C","cls2":"PreprintSuggestionsStep-cls2_Iit PreprintSuggestionsStep-cls1_I4C"};